import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";

import { apiUrl } from "../config/url";
import Navbar from './Navbar';

const ChangePass = () => {

    const user_id = localStorage.getItem("user_id");
    const user_role = localStorage.getItem("user_role");


    const [passwordData, setPasswordData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
    });
    const [errorMessage, setErrorMessage] = useState('');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPasswordData({ ...passwordData, [name]: value });
    };

    const handleChangePassword = async (e) => {
        e.preventDefault();
        setErrorMessage(''); // Reset any error message

        // Validation for passwords
        if (passwordData.newPassword !== passwordData.confirmPassword) {
            setErrorMessage("New passwords do not match!");
            return;
        }

        try {
            const token = localStorage.getItem("api_token");
            const user_id = localStorage.getItem("user_id"); // Assuming you're fetching user_id from localStorage

            console.log(token);

            const response = await axios.post(`${apiUrl}/admin/updateLogin`, {
                old_pass: passwordData.currentPassword,
                user_id: user_id, // Corrected this line to properly assign 
                api_token: token,
                new_pass: passwordData.newPassword,
            }, {
                headers: {
                    api_token: token,
                },
            });


            console.log("API Response:", response.data);
            if (response.data.status==true) {
                toast.success("Password changed successfully!");
                setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' }); // Reset form
            } else {
                toast.error(response.data.message || "Failed to change password");
            }
        } catch (error) {
            console.error("Error changing password:", error);
            toast.error("An error occurred while changing password");
        }
    };

    return (
        <>
            <Navbar />
            <div className="flex items-center justify-center min-h-screen p-5">
            <ToastContainer />
                <div className="bg-white p-8 rounded-lg shadow-lg max-w-lg w-full border-l-4 border-indigo-600">
                    <h1 className="text-3xl font-bold mb-6 text-center text-indigo-600">Change Password</h1>
                    {errorMessage && <p className="text-red-600 mb-4 text-center">{errorMessage}</p>}
                    <form onSubmit={handleChangePassword}>
                        {user_role === "2" && (
                            <div className="mb-4">
                                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="currentPassword">
                                    Current Password
                                </label>
                                <input
                                    type="password"
                                    name="currentPassword"
                                    id="currentPassword"
                                    value={passwordData.old_pass}
                                    onChange={handleInputChange}
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    required
                                />
                            </div>
                        )}

                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="newPassword">
                                New Password
                            </label>
                            <input
                                type="password"
                                name="newPassword"
                                id="newPassword"
                                value={passwordData.new_pass}
                                onChange={handleInputChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                required
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="confirmPassword">
                                Confirm New Password
                            </label>
                            <input
                                type="password"
                                name="confirmPassword"
                                id="confirmPassword"
                                value={passwordData.confirmPassword}
                                onChange={handleInputChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                        >
                            Change Password
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
};

export default ChangePass;
